const isURL = (value) => /(\w{2,}\.\w{2,})/.test(value);
const isEmail = (value) => /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/.test(value);
const isNumber = (value) => /^-?\d*(\.\d+)?$/.test(value);
const isInteger = (value) => /^-?\d*$/.test(value);
const getIsOverMinFn = (minValue) => (value) => Number.parseFloat(value) >= minValue;
const getIsUnderMaxFn = (maxValue) => (value) => Number.parseFloat(value) <= maxValue;
export { isURL, isEmail, isNumber, isInteger, getIsOverMinFn, getIsUnderMaxFn };
